import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrackingService } from '../../utils/trackingService';
import { Container, NavContainer, LogoContainer, Logo } from './styles';

interface Props {
  onClose?: () => void;
  showAction?: boolean;
  onLearnMore?: () => void;
  onHeightChange?: (height: number) => void;
}

const Header: React.FC<Props> = ({ onHeightChange }) => {
  const navigate = useNavigate();
  const containerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !onHeightChange) return;

    onHeightChange(el.getBoundingClientRect().height);

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const height =
          entry.borderBoxSize?.[0]?.blockSize ??
          entry.target.getBoundingClientRect().height;
        onHeightChange(height);
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [onHeightChange]);

  return (
    <Container ref={containerRef}>
      <NavContainer>
        <LogoContainer
          onClick={() => {
            TrackingService.track('header_logo_clicked');
            navigate('/');
          }}
        >
          <Logo src="/niyyah-logo-black.png" alt="Niyyah" />
        </LogoContainer>
      </NavContainer>
    </Container>
  );
};

export { Header };
